// @flow
import type { PriceFormat, ApiConfig } from "bb-api-sdk";
/**
 * 
 * 
 * @ignore
 *
 */
class GlobalConfig {
  static instance = null;
  productName: String;
  style: String;
  priceFormat: PriceFormat;
  locale: 'en' | 'it';
  contentApiConfig: ApiConfig;
  betServiceApiConfig: ApiConfig;
  maxSelectionsPerMarket: number;

  constructor() {
    if (!GlobalConfig.instance) {
      GlobalConfig.instance = this;
    }
    return GlobalConfig.instance;
  }
}

const globalConfig = new GlobalConfig();

export default globalConfig;



// WEBPACK FOOTER //
// ./src/config/index.js